import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  searchContainer: {
    flex: 2,
    position: 'relative',
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  },

  input: {
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '12px 12px',
    },
    borderRadius: '50px',
    border: `1px solid ${zeplinColor.Neutral6}`,
    '&.Mui-focused': { border: `1px solid ${zeplinColor.Neutral6}` },
  },
};
